<router-outlet></router-outlet> 
